<template>
  <div class='listContent'>
    <div class="head_div">
      <div class="title_div">
        <span>当日日程</span>
        <span class="dot">•</span>
        <span>{{todayScheduleList.length}}</span>
      </div>
      <div class="to_today_div">
        <div class="to_today_btn" @click="toToday">去今天</div>
      </div>
      <div class="add_schedule_div" @click="showAddScheduleDialog">
        <i class="icon iconfont icon-add2"></i>添加日程
      </div>
    </div>
    <div class="content schedule_content">
      <scheduleList></scheduleList>
    </div>
  </div>
</template>

<script>
import scheduleList from '../../others/scheduleList.vue'
import projectList from '../../others/projectList.vue'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'listContent',
  components: {
    scheduleList,
    projectList
  },
  data: function () {
    return {
      activeName: 'second',
      month: '',
      day: '',
      weekday: ''
    }
  },
  computed: {
    ...mapState([
      'projectList',
      'todayScheduleList',
      'selectDate'
    ])
  },
  watch: {
    selectDate: function (newVal, oldVal) {
      this.formDateInfo(newVal)
    }
  },
  methods: {
    toToday () {
      this.$store.dispatch('setSelectDate', moment().format('YYYY-MM-DD'))
      this.$store.dispatch('setTodayScheduleList')
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    showAddScheduleDialog () {
      this.$store.dispatch('setSelectDate', this.selectDate)
      let data = {
        visible: true,
        method: 'add',
        no: ''
      }
      this.$store.dispatch('setScheduleDialog', data)
    },
    formDateInfo (date) {
      this.month = moment(date).format('MM')
      this.day = moment(date).format('DD')
      let weekday = moment(date).format('e')
      switch (weekday) {
        case '1':
          this.weekday = '周一'
          break
        case '2':
          this.weekday = '周二'
          break
        case '3':
          this.weekday = '周三'
          break
        case '4':
          this.weekday = '周四'
          break
        case '5':
          this.weekday = '周五'
          break
        case '6':
          this.weekday = '周六'
          break
        case '0':
          this.weekday = '周日'
          break
        default:
          console.log('解析星期错误')
      }
    }
  },
  created: function () {
    this.formDateInfo(moment().format('YYYY-MM-DD'))
  }
}
</script>

<style lang="stylus" scoped>
  .listContent
    width 21.4375rem
    height 100%
    border-right 0.0625rem solid $tinGrey
    .head_div
      height 2.5rem
      line-height 2.5rem
      background $bgGray
      border-bottom 0.0625rem solid $tinGrey
      .title_div
        display inline-block
        margin-left 1.25rem
      .to_today_div
        display inline-block
        margin-left 1.25rem
        .to_today_btn:hover
          cursor pointer
          color $white
          background $darkBlue
        .to_today_btn
          display inline-block
          vertical-align text-top
          line-height 1.3rem
          width 3.5rem
          height 1.1rem
          font-size 0.75rem
          color $darkBlue
          text-align center
          border 0.0625rem solid $darkBlue
          border-radius 0.125rem
      .add_schedule_div:hover
        cursor pointer
        color $lightGrey
      .add_schedule_div
        margin-left 2.25rem
        display inline-block
        color $darkBlue
        i
          margin-right 0.5rem
    .content
      height 93%
      border-radius 0.75rem
      .title
        height 1.375rem
        line-height 1.375rem
        .date
          margin-left 5rem
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/component/listContent.vue